import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../config.service';
import {CheckoutService} from '../checkout/checkout.service';
import {AccountVerificationService} from '../account-verification.service';
import {forkJoin, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ProfileService} from '../profile.service';
import {ProfileItemModelService} from '../profile-item-model.service';

@Injectable()
export class ShoppingInStoreResolverService implements Resolve<any> {

    constructor(
        private checkoutService: CheckoutService,
        private verificationService: AccountVerificationService,
        private profileService: ProfileService,
        private profileModelService: ProfileItemModelService,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        return forkJoin({
            dataValidation: this.checkoutService.verifyUserInfo().pipe(catchError(err => of(err))),
            user: this.profileService.clienteAPI('SL', null).pipe(catchError(err => of(err))),
            profileModel: this.profileModelService.getProfileModel().pipe(catchError(err => of(err))),
            defaultPayment: this.checkoutService.getDefaultPayment().pipe(catchError(err => of(err))),
            code: this.verificationService.requestCodeWithNoDisturb().pipe(catchError(err => of(err)))
        });
    }
}
